export default __webpack_public_path__ + "static/media/area-rectangle-2.172cff90.svg";